import React from 'react';
import { FaIcon, StyledContainer } from '@atomic';
import { BackButtonArrow, InfoHeader } from '../course-library-header/course-library-header.component.style';
// Cópia do LibraryHeader com o "voltar" controlado pela página (sai de uma pasta por vez).
// O original não é alterado; os estilos são reaproveitados sem mudança.
export var LibraryHeaderV3 = function (_a) {
    var title = _a.title, onBack = _a.onBack;
    return (React.createElement(StyledContainer, { primaryColor: true, style: { display: 'flex' }, className: "use-inverse-colors" },
        React.createElement(BackButtonArrow, null,
            React.createElement(FaIcon.ArrowLeft, { onClick: onBack })),
        React.createElement(InfoHeader, null,
            React.createElement("h1", null, "Biblioteca"),
            React.createElement("h2", null, title))));
};
